<template>
  <form class="p-2" @submit.prevent="handleAddDriver">
    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0">{{ $t("add-driver") }}</h4>
      </template>

      <template slot="body">
        <div class="form-group">
          <label for="name">{{ $t("company-name") }}</label>
          <input
            type="text"
            name="name"
            v-model="name"
            class="form-control"
            required
            id="name"
            :placeholder="$t('enter-full-name')"
            @keypress="isLetter($event)"
          />
        </div>
        <div class="form-group">
          <label for="email">{{ $t("email") }}</label>
          <input
            v-model="email"
            type="text"
            name="email"
            class="form-control"
            required
            id="email"
            :placeholder="$t('enter-email')"
          />
        </div>

        <div class="form-group w-100">
          <label for="phone">{{ $t("phone_num") }}</label>
          <input
            type="tel"
            v-model="phoneNumber"
            class="form-control"
            required
            id="phone_number"
            :placeholder="$t('enter-phonenumber')"
          />
          <!-- <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                  {{ ErrorPhone }}
                </p> -->
        </div>

        <div class="form-group w-100">
          <label for="phone">{{ $t("company-address") }}</label>
          <input
            type="text"
            v-model="companyAddress"
            class="form-control"
            required
            id="phone"
            :placeholder="$t('enter-companyAddress')"
          />
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";

export default {
  name: "AddPartner",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    partner: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: this.partner?.name || "",
      email: this.partner?.email || "",
      phoneNumber: this.partner?.phoneNumber || "",
      companyAddress: this.partner?.address || "",
    };
  },
  methods: {
    handleAddDriver() {
      this.$emit("partnerDetails", {
        name: this.name,
        email: this.email,
        phoneNumber: this.phoneNumber,
        address: this.companyAddress,
      });
      this.onCancel();
    },
      isLetter(e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
        else e.preventDefault();
      },
  },
  watch: {
    partner: {
      handler(newValues) {
        this.name = newValues.name || "";
        this.email = newValues.email || "";
        this.phoneNumber = newValues.phoneNumber || "";
        this.companyAddress = newValues.address || "";
      },
      deep: true,
    },
  },
};
</script>

<style></style>
